<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">

            <div class="row" style="margin-top: 50px" v-if="usuario">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/usuarios"><i class="fa fa-user-circle" aria-hidden="true"></i> USUÁRIOS</a></li>
                    <li class="active">CADASTRO DE USUÁRIOS</li>
                </ol>

                <div class="col-md-3">

                </div>
                <div class="col-md-9" >

                    <dados-usuario :usuario="usuario"></dados-usuario>
                    <permissoes :permissoes="usuario.permissoes"></permissoes>

                    <div class="form-group">
                        <div class="col-sm-10">
                            <button type="button" @click="send()" class="btn btn-success">
                                <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR USUÁRIO
                            </button>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>
</template>
<script>
import Vue from "vue";
import { Usuario } from "../../../class/index";
import { Permissoes, DadosUsuario } from "../../../components/exports";
export default {
    components: {
        Permissoes,
        DadosUsuario
    },
    data() {
        return {
            usuario: null
        };
    },
    beforeRouteEnter(to, from, next) {
        Usuario.level()
            .then(data => {
                if (data.level === 1) {
                    return next();
                }
                window.location.href = Vue.http.options.root;
            })
            .catch(() => {
                window.location.href = Vue.http.options.root;
            });
    },
    beforeMount() {
        Usuario.byPK(this.$route.params.id)
            .then(data => (this.usuario = data))
            .catch(err => {
                if (err.data && err.data.code === 401) {
                    window.location.href = Vue.http.options.root;
                }
                this.config = Usuario.create();
            });
    },
    methods: {
        send() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o usuário?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Usuario.save(this.usuario)
                                .then(() => {
                                    this.$router.push("/usuarios");
                                    resolve();
                                })
                                .catch(err => {
                                    if (err.data && err.data.code === 403) {
                                        return swal(
                                            "Email",
                                            "Email já sendo usado",
                                            "error"
                                        );
                                    }
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
